
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2021-01-21-starting-fe-project",
      function () {
        return require("private-next-pages/blogs/2021-01-21-starting-fe-project/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2021-01-21-starting-fe-project"])
      });
    }
  